import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { Layout as DashboardLayout } from 'src/layouts/dashboard';
import { Outlet } from 'react-router-dom';

const Dashboard = lazy(() => import('src/pages/dashboard/dashboard'));
const TermBoard = lazy(() => import('src/pages/dashboard/termboard'));
const MenualBoard = lazy(() => import('src/pages/dashboard/manualboard'));
const RewardBoard = lazy(() => import('src/pages/dashboard/rewardboard'));

export const dashboardRoutes: RouteObject[] = [
  {
    path: '/dashboard',
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />
      },
      {
        path: 'terms',
        element: <TermBoard />
      },
      {
        path: 'rewards',
        element: <RewardBoard />
      },
      {
        path: 'manual',
        element: <MenualBoard />
      }
    ]
  }
];
